import { render } from "./Medicos.vue?vue&type=template&id=3123f394&scoped=true"
import script from "./Medicos.vue?vue&type=script&lang=js"
export * from "./Medicos.vue?vue&type=script&lang=js"

import "./Medicos.vue?vue&type=style&index=0&id=3123f394&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3123f394"]])

export default __exports__